<h1 mat-dialog-title>Send to the patient's app</h1>

<div mat-dialog-content class="sed">
    <mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>

    <div class="sed__alert" *ngIf="loadError" data-test="load-error">
        <mat-icon>error_outline</mat-icon>
        <div>{{ loadError }}</div>
    </div>

    <ng-container *ngIf="!isLoading && !loadError">
        <div class="sed__entry" data-test="entry">
            <mat-icon>phonelink_ring</mat-icon>
            <div>
                <div class="sed__entry-title">{{ data.entryTitle }}</div>
                <div class="hint">{{ data.patientName }}</div>
            </div>
        </div>

        <p class="hint" *ngIf="!linked" data-test="not-linked">
            This patient's file is not linked to the patient app, so nothing can be sent. A patient links their file by
            choosing "Save to the app" when they complete your invite.
        </p>

        <ng-container *ngIf="linked">
            <p class="hint" *ngIf="inApp" data-test="in-app">
                Already in the patient's app, sent {{ current?.lastSentAt || current?.sharedAt | date: 'd MMM y, HH:mm' }}. When this entry is
                edited, the new version is sent too, marked "Edited".
            </p>
            <p class="hint" *ngIf="current?.withdrawnAt" data-test="withdrawn">
                Withdrawn on {{ current?.withdrawnAt | date: 'd MMM y' }}. You can send it again.
            </p>
            <ng-container *ngIf="!inApp && canShare">
                <p class="hint">The patient receives a copy of this entry only. The rest of the file stays with the practice.
                    Later edits are sent to them automatically.</p>
                <mat-checkbox [(ngModel)]="confidential" data-test="confidential">
                    Confidential to the patient (12–17)
                </mat-checkbox>
                <p class="hint" *ngIf="confidential">
                    Only the teenager's own app access shows it; a parent or guardian managing their profile cannot see it or
                    tell that it exists. If the teenager has no access of their own yet, it is not delivered at all: tell them in
                    person. The medical aid statement is outside the app and may still reach the account holder.
                </p>
            </ng-container>
            <p class="hint" *ngIf="!canShare && !inApp" data-test="cannot-share">Only administrators and physicians can send entries to a patient's app.</p>
        </ng-container>

        <div class="sed__alert" *ngIf="actionError" data-test="action-error">
            <mat-icon>error_outline</mat-icon>
            <div>{{ actionError }}</div>
        </div>
    </ng-container>
</div>

<div mat-dialog-actions align="end">
    <button mat-button (click)="close()" [disabled]="isSaving">Close</button>
    <button mat-stroked-button color="warn" *ngIf="linked && inApp && canWithdraw" (click)="withdraw()" [disabled]="isSaving" data-test="withdraw">
        Withdraw…
    </button>
    <button mat-flat-button color="primary" *ngIf="linked && !inApp && canShare" (click)="send()" [disabled]="isSaving" data-test="send">
        {{ isSaving ? 'Sending…' : 'Send to the app' }}
    </button>
</div>
